export default __webpack_public_path__ + "static/media/phone.8cb1f203.gif";